import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { formatPen } from "../../../../utils/finance/format";

function KpiCard({ label, value }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="body2" color="text.secondary">{label}</Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>{value}</Typography>
      </CardContent>
    </Card>
  );
}

export function FinanceKpiCards({ kpis }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Ventas (PEN)" value={formatPen(kpis?.sales_pen)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Pagos recibidos (PEN)" value={formatPen(kpis?.payments_pen)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Gastos (PEN)" value={formatPen(kpis?.expenses_pen)} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard label="Pendiente por cobrar (PEN)" value={formatPen(kpis?.receivables_pen)} />
      </Grid>
    </Grid>
  );
}
